<div class="field">
  <label for="PersonSelectorDd" class="do-not-wrap-text" *ngIf="showLabel">{{labelKey}} ({{selectedID}})</label>
  <p-dropdown id="PersonSelectorDd"
              [options]="_personslistMC"
              optionLabel="personSaveAs"
              optionDisabled="disAllowSelect"
              optionGroupLabel="PERSRESPONSIBLESTR"
              [group]="false"
              [(ngModel)]="_personMC"
              [placeholder]="placeholder"
              filterPlaceholder="Поиск контакта..."
              [filter]="true"
              filterBy="personSaveAs"
              [showClear]="showClear"
              [required]="true"
              [disabled]="disabled"
              [virtualScrollItemSize]="31"
              [readonly]="readonly"
              (onChange)="onChangePS($event)"
              (onClear)="onClearPS($event)">

  </p-dropdown>
</div>
